import { jsxs as o, jsx as i } from "react/jsx-runtime";
import { useTranslation as s } from "react-i18next";
import { LinkAnchor as a } from "../../../../../components/elements/link/link.js";
import m from "./cancellation-completed.module.less.js";
const l = ({ bookingId: e, cancellationCompletedLink: r }) => {
  const { t } = s();
  return /* @__PURE__ */ o("div", { className: [m.wrapper, "max-width padded-sides centered"].join(" "), children: [
    /* @__PURE__ */ i("h1", { className: "h2 heading-max-width", children: t("TRAILER_RENTAL_CANCELLATION_COMPLETE_HEADING") }),
    /* @__PURE__ */ i("p", { className: "body-l text-max-width", children: t("TRAILER_RENTAL_CANCELLATION_COMPLETE_TEXT", { bookingNumber: e }) }),
    r && /* @__PURE__ */ i(
      a.Primary,
      {
        label: r?.title,
        url: r?.url,
        iconRight: "ui-icon-arrow-right"
      }
    )
  ] });
};
export {
  l as CancellationCompleted
};
